import React, { useState, useRef } from "react";
import DragAndDropUpload from "./components/DragAndDropUpload";
import exifr from "exifr";
import "./App.css";
import logoButton from "./assets/fist_2020_flat.png";
import kofiButton from "./assets/kofi-button.png";

function App() {
  const [metadata, setMetadata] = useState(null);
  const [preview, setPreview] = useState("");
  const [showUpload, setShowUpload] = useState(true);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownContentRef = useRef(null);

  // Handle file upload and metadata extraction
  const handleFilesAccepted = async (files) => {
    const file = files[0];
    if (!file) return;

    // Show preview
    const reader = new FileReader();
    reader.onload = (e) => setPreview(e.target.result);
    reader.readAsDataURL(file);

    // Extract metadata
    try {
      const exifData = await exifr.parse(file);
      setMetadata({
        basic: {
          name: file.name,
          size: `${(file.size / 1024).toFixed(2)} KB`,
          type: file.type,
          lastModified: new Date(file.lastModified).toLocaleString(),
        },
        exif: exifData || "No EXIF data found",
      });
    } catch (error) {
      setMetadata({ error: "Could not read metadata" });
    }
    setShowUpload(false);
  };

  // Copy metadata to clipboard
  const handleCopyMetadata = () => {
    navigator.clipboard
      .writeText(JSON.stringify(metadata, null, 2))
      .then(() => alert("Metadata copied to clipboard"))
      .catch((err) => alert("Copy failed: " + err));
  };

  // Print metadata
  const handlePrintMetadata = () => {
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head><title>Image Metadata</title></head>
        <body>
          <pre>${JSON.stringify(metadata, null, 2)}</pre>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
  };

  // Reset to upload a new photo
  const handleUploadNew = () => {
    setPreview("");
    setMetadata(null);
    setShowUpload(true);
  };

  return (
    <div className="App">
      <div className="logo-section">
        <a
          href="https://freemetadatareader.robifazio.com"
          target="_self"
          rel="noopener noreferrer"
        >
          <img
            src={logoButton}
            alt="Fight for creativity"
            className="logo-button"
          />
        </a>
      </div>
      <div className="container">
        <div
          style={{
            maxWidth: 600,
            margin: "2rem auto",
            fontFamily: "Arial, sans-serif",
          }}
        >
          <h1 style={{ textAlign: "center" }}>Image Metadata Reader</h1>

          {showUpload && (
            <DragAndDropUpload onFilesAccepted={handleFilesAccepted} />
          )}

          {preview && metadata && (
            <div style={{ textAlign: "center", marginTop: "2rem" }}>
              <img
                src={preview}
                alt="Upload preview"
                style={{
                  maxWidth: "300px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  marginBottom: "1rem",
                }}
              />
              {/* <div
            style={{
              display: "flex",
              gap: "1rem",
              justifyContent: "center",
              marginBottom: "1rem",
            }}
          >
            <Button variant="contained" onClick={handleCopyMetadata}>
              Copy metadata to Clipboard
            </Button>
            <Button variant="contained" onClick={handlePrintMetadata}>
              Print metadata
            </Button>
            <Button variant="outlined" onClick={handleUploadNew}>
              Upload a new photo
            </Button>
          </div> */}

              <div className="action-buttons">
                <button onClick={handleCopyMetadata}>
                  Copy metadata to Clipboard
                </button>
                <button onClick={handlePrintMetadata}>Print metadata</button>
                <button onClick={handleUploadNew} className="danger-btn">
                  Upload a new photo
                </button>
                {!navigator.clipboard?.write && (
                  <p className="browser-warning">
                    Clipboard copy not supported in your browser
                  </p>
                )}
              </div>
              <pre
                style={{
                  background: "#f4f4f4",
                  padding: "1rem",
                  borderRadius: "1vw",
                  textAlign: "left",
                  whiteSpace: "pre-wrap",
                  margin: "3vh auto",
                  width: "90%",
                }}
              >
                {JSON.stringify(metadata, null, 2)}
              </pre>
            </div>
          )}

          {/* Dropdown Accordion */}
          <div className="dropdown-container">
            <button
              className="dropdown-title"
              onClick={() => setIsDropdownOpen((open) => !open)}
            >
              What is metadata?
              <span
                className={`dropdown-arrow${isDropdownOpen ? " open" : ""}`}
              >
                ▼
              </span>
            </button>
            <div
              ref={dropdownContentRef}
              className={`dropdown-content${isDropdownOpen ? " open" : ""}`}
              style={{
                maxHeight: isDropdownOpen
                  ? dropdownContentRef.current
                    ? dropdownContentRef.current.scrollHeight
                    : "200px"
                  : 0,
              }}
            >
              <p>
                Metadata in an image file is information embedded within or
                associated with the file that describes various aspects of the
                image, but not the image content itself. This can include
                technical details like the camera model, exposure settings, date
                and time the photo was taken, and image dimensions (EXIF data),
                as well as descriptive information such as the photographer's
                name, keywords, captions, and copyright or licensing details
                (IPTC or XMP data). Metadata helps organize, search, and manage
                image files efficiently, and can also include location data (GPS
                coordinates) and color profiles for accurate display.
              </p>
            </div>
          </div>
        </div>

        <div className="support-section">
          <a
            href="https://ko-fi.com/robifazio"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={kofiButton}
              alt="Buy me a coffee on Ko-fi"
              className="kofi-button"
            />
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;
